// extracted by mini-css-extract-plugin
module.exports = {"nav":"SearchNav_nav__oqlAw","vertical":"SearchNav_vertical__48_bH","cards":"SearchNav_cards__HpLWt"};